import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "../app/Login/Service/Login.Service";
import { LoginModel } from "../app/model/index";
declare var appself: any;
declare var require: any;

@Component({
    selector: "MentisSoft-application",
    template: require('./app.template.html'),
    styles: [require('./app.css')],
    providers: [LoginService]
})
export class ApplicationComponent implements OnInit{
    logoutsite: string = "";

    constructor(private _LoginService: LoginService) {
    }
    loginInfo: LoginModel = new LoginModel();
    HospitalName: string = "";
    PortalType: string = "";

    /* Triger onInit */
    ngOnInit(): void {
        this._LoginService.GetLogo(this.loginInfo)
            .subscribe(function (s) {
                if (s != null) {
                    this.HospitalName = s.HospitalName;
                    this.PortalType = s.PortalType;
                    this.CPRNOlength = s.CPRNOlength;
                    localStorage.setItem("PortalType", this.PortalType);
                    localStorage.setItem("HospitalName", this.HospitalName);
                    localStorage.setItem("CPRNOlength", this.CPRNOlength);
                }
            });

        if (localStorage.getItem("HospitalName") == null || localStorage.getItem("HospitalName") == "" || localStorage.getItem("HospitalName") == undefined) {
        } else {
            if (localStorage.getItem("HospitalName") == "IBN")
                this.loadCredimaxJS();
            if (localStorage.getItem("HospitalName") == "BSH")
                this.loadCredimaxJSBSH();
        }
    }


    loadCredimaxJS() {

        if (!window.document.getElementById('credimax-script')) {
            var s = window.document.createElement("script");
            s.id = "credimax-script";
            s.type = "text/javascript";
            s.src = "https://credimax.gateway.mastercard.com/checkout/version/61/checkout.js";
            window.document.getElementsByTagName('head')[0].appendChild(s);
        } 
    }

    loadCredimaxJSBSH() {

        if (!window.document.getElementById('credimax-script')) {
            var s = window.document.createElement("script");
            s.id = "credimax-script";
            s.type = "text/javascript";
            s.src = "https://credimax.gateway.mastercard.com/checkout/version/61/checkout.js";
            window.document.getElementsByTagName('head')[0].appendChild(s);
        }
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/app.component.ts